/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: files.fga
 * Run: pnpm run gen:permissions -- files
 */

import type { ModulePermissions } from './types';

export const filesPermissions = {
  module: 'files',
  displayName: 'Files',
  entities: [
    {
      name: 'file',
      displayName: 'File',
      permissions: [
        { key: 'fileRead', action: 'Read', category: 'crud' },
        { key: 'fileWrite', action: 'Write', category: 'custom' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Files module
 */
export type FilesPermissionKey = 'fileRead' | 'fileWrite';
